import React from 'react';
import { Alert } from 'antd';
import { DataStatus } from '../../services/DashboardService';

interface DataStatusAlertProps {
  dataStatus: DataStatus | null;
  viewMode: 'weekly' | 'quarterly';
  onClose: () => void;
}

export const DataStatusAlert: React.FC<DataStatusAlertProps> = ({
  dataStatus,
  viewMode,
  onClose,
}) => {
  if (!dataStatus || dataStatus.allDataAvailable) {
    return null;
  }

  return (
    <Alert
      message="Missing Data"
      description={
        <div>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>{dataStatus.message}</div>
          {dataStatus.missingDataSources && dataStatus.missingDataSources.length > 0 && (
            <div style={{ fontSize: 13 }}>
              <strong>Missing sources:</strong> {dataStatus.missingDataSources.join(', ')}
            </div>
          )}
          {viewMode === 'weekly' &&
            dataStatus.partialGfsData &&
            dataStatus.missingWeeks &&
            dataStatus.missingWeeks.length > 0 && (
              <div style={{ fontSize: 13, marginTop: 4 }}>
                <strong>Missing GFS weeks:</strong>{' '}
                {dataStatus.missingWeeks.sort((a, b) => a - b).join(', ')}
              </div>
            )}
        </div>
      }
      type="warning"
      showIcon
      closable
      onClose={onClose}
      style={{ marginBottom: 16 }}
    />
  );
};

